import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionKeeperService } from './session-keeper.service';

@Injectable()
export class SessionKeeperInterceptor implements HttpInterceptor {
	readonly #sessionKeeperService = inject(SessionKeeperService);

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// TODO: Check if URL extends session
		// console.log(req.url);

		this.#sessionKeeperService.reset();

		return next.handle(req);
	}
}
